import Layout from "@/components/shared/Layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import SeoPageMeta from "@/components/seo/SeoPageMeta";
import SeoPageHero from "@/components/seo/SeoPageHero";
import SeoPageStats from "@/components/seo/SeoPageStats";
import SeoPageAudience from "@/components/seo/SeoPageAudience";
import SeoPageCurriculum from "@/components/seo/SeoPageCurriculum";
import SeoPageAdvantages from "@/components/seo/SeoPageAdvantages";
import SeoPageProcess from "@/components/seo/SeoPageProcess";
import SeoPageFAQ from "@/components/seo/SeoPageFAQ";
import SeoPageContent from "@/components/seo/SeoPageContent";
import { fetchSeoPageBySlug } from "@/utils/seo/fetchSeoPage";
import { isReservedSlug } from "@/utils/seo/reservedSlugs";

export async function getServerSideProps({ locale, params, query }) {
  const { slug } = params;

  if (isReservedSlug(slug)) {
    return { notFound: true };
  }

  const lang = query.lang || locale || "az";
  let seoPage = await fetchSeoPageBySlug(slug, lang);

  if (!seoPage && lang !== "az") {
    seoPage = await fetchSeoPageBySlug(slug, "az");
  }

  if (!seoPage) {
    return { notFound: true };
  }

  return {
    props: {
      seoPage,
      ...(await serverSideTranslations(locale || "az")),
    },
  };
}

export default function SeoTagPage({ seoPage }) {
  return (
    <Layout>
      <SeoPageMeta seoPage={seoPage} />
      <SeoPageHero seoPage={seoPage} />
      <SeoPageStats seoPage={seoPage} />
      <SeoPageAudience seoPage={seoPage} />
      <SeoPageCurriculum seoPage={seoPage} />
      <SeoPageAdvantages seoPage={seoPage} />
      <SeoPageProcess seoPage={seoPage} />
      <SeoPageFAQ seoPage={seoPage} />
      <SeoPageContent seoPage={seoPage} />
    </Layout>
  );
}
